import axios from 'axios';
import React, { useState } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import '../styling/enterquiz.css';

export default function Enterquiz() {
    const [loading, setloading] = useState(false);
    const navigate = useNavigate();
    const { userid, name } = useParams();
    const fetchhandler = async () => {
        setloading(true);
        const response = await axios.get(`https://quiz-backend-mqz8.onrender.com/answer/${userid}`);
        const resdata = await response.data;
        const questiondata = await resdata.data;
        const oponentid = await resdata.userid;
        localStorage.setItem(`oponent_data`, `${JSON.stringify(await questiondata)}`);
        localStorage.setItem(`oponent_userid`, `${await oponentid}`);
        setloading(false);
        navigate('/playername');
    }
    if (localStorage.getItem('login_user_id') === userid) {
        return <Navigate to='/result' />
    }
    return (
        <>
            {localStorage.getItem(`${userid}`) ? <Navigate to='/score' /> :
                <div className='enterquiz'>
                    <div className="quizbox">
                        <div className="quizhead"><h2 className="quizheading">Guess about your friend <span className="headname">{name}</span></h2></div>
                        <div className="quizmat">
                            <div className="inst">Accept the challenge and answer 9 questions to find out how well you really know your friend!</div>
                        </div>
                        <div className="btndiv">
                            <div className={`stbtn ${loading ? "load" : ""}`} onClick={fetchhandler}><span className='quizstbtn' >Start</span></div>
                        </div>
                    </div>
                    <div className="homemat">
                        <div className="mat">
                            <h2 className="mathead">Questions</h2>
                            <div className='matcon'>Get ready to answer some simple questions about your friend. For example "Where would your friend like to go on vacation?" or "What's life about to your friend?"</div>
                        </div>
                        <div className="mat">
                            <h2 className="mathead">Fun</h2>
                            <div className='matcon'>This page is intended for fun only! You'll see your friends' results chart. If someone gets all the answers right, they will score 9 points.</div>
                        </div>
                        <div className="mat">
                            <h2 className="mathead">Answers</h2>
                            <div className='matcon'>It's not an exam ;-), so don’t debate for too long about which answers to mark. Just select the one that seems to describe your friend most accurately at first glance..</div>
                        </div>
                        <div className="mat">
                            <h2 className="mathead">Create your quiz</h2>
                            <div className='matcon'>When you finish your friend's quiz, you can create your own quiz. Then you can share it with your friends to check how well they really know you :-).</div>
                        </div>
                    </div>
                </div>}
        </>
    )
}
